import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const moduleWeather = {
  namespaced: true,

  state: {
    name: 'weather',
    weatherEntries:[]
  },

  mutations,
  getters,
  actions
}

export default moduleWeather;